import React from 'react';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Hero() {
  return <div className="relative h-screen min-h-[700px] max-h-[900px] flex items-center overflow-hidden" data-id="element-31">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-32">
        <img src="https://cdn.magicpatterns.com/uploads/qQpu5DhumMpRzyKNNpctrK/ChatGPT_Image_Mar_16,_2026,_05_46_35_PM.png" alt="Worship at The Household" className="w-full h-full object-cover object-top" data-id="element-33" />
        {/* Dark gradient overlay using Deep Navy and Secondary Blue */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1F44]/85 via-[#163A70]/50 to-[#0A1F44]/80" data-id="element-34" />

        {/* Heavenly light rays effect */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(255,255,255,0.15)_0%,transparent_60%)] mix-blend-overlay pointer-events-none" data-id="element-35" />

        {/* Glow effect around the cross area (right side) */}
        <div className="absolute top-1/4 right-1/4 w-[600px] h-[600px] bg-[#163A70]/40 blur-[120px] rounded-full pointer-events-none mix-blend-screen" data-id="element-36" />
      </div>

      {/* Main Content */}
      <div className="container-custom relative z-10 px-4 mt-16 md:mt-24 w-full" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto md:mx-0 md:ml-[5%] lg:ml-[8%] flex flex-col items-center md:items-start text-center md:text-left" data-id="element-38">
          {/* Welcome Text */}
          <motion.span initial={{
          opacity: 0,
          letterSpacing: '0em'
        }} animate={{
          opacity: 1,
          letterSpacing: '0.35em'
        }} transition={{
          delay: 0.2,
          duration: 1
        }} className="text-white/90 text-base md:text-lg font-serif italic tracking-[0.35em] mb-3 md:mb-5 block" style={{
          textShadow: '0 2px 15px rgba(0,0,0,0.6)'
        }} data-id="element-39">
            WELCOME HOME TO
          </motion.span>

          {/* Main Title - THE in red, HOUSEHOLD in white */}
          <motion.h1 initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="text-[2.5rem] sm:text-5xl md:text-7xl lg:text-[6.5rem] font-serif font-bold leading-none mb-0" style={{
          textShadow: '0 4px 30px rgba(0,0,0,0.6)'
        }} data-id="element-40">
            <span className="text-[#C8102E]" data-id="element-41">THE</span>
            <span className="text-white" data-id="element-42">HOUSEHOLD</span>
          </motion.h1>

          {/* Script Subtitle */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} className="font-script text-white text-3xl sm:text-5xl md:text-7xl lg:text-8xl mt-2 md:mt-0 mb-8 md:mb-12 relative z-10" style={{
          textShadow: '0 4px 25px rgba(0,0,0,0.5)'
        }} data-id="element-43">
            Gateway of Heaven
          </motion.div>

          {/* Tagline */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8,
          duration: 0.8
        }} className="text-white/90 text-lg md:text-2xl font-serif italic mb-10 md:mb-14 max-w-2xl" style={{
          textShadow: '0 2px 15px rgba(0,0,0,0.5)'
        }} data-id="element-44">
            A Christ-Centered Family where Heaven touches Earth
          </motion.p>

          {/* CTA Buttons */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1,
          duration: 0.8
        }} className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 w-full sm:w-auto" data-id="element-45">
            <Link to="/visit" className="w-full sm:w-auto" data-id="element-46">
              <Button variant="primary" size="lg" className="w-full sm:w-auto font-bold tracking-wider text-sm md:text-base px-8 py-4 shadow-lg shadow-red-900/30" data-id="element-47">
                JOIN US THIS SUNDAY
              </Button>
            </Link>
            <Link to="/live" className="w-full sm:w-auto" data-id="element-48">
              <Button variant="outline-white" size="lg" className="w-full sm:w-auto font-bold tracking-wider text-sm md:text-base px-8 py-4 bg-black/20 backdrop-blur-sm hover:bg-white hover:text-[#0A1F44]" data-id="element-49">
                WATCH LIVE
              </Button>
            </Link>
            <Link to="/visit" className="w-full sm:w-auto" data-id="element-50">
              <Button variant="outline-white" size="lg" className="w-full sm:w-auto font-bold tracking-wider text-sm md:text-base px-8 py-4 bg-black/20 backdrop-blur-sm hover:bg-white hover:text-[#0A1F44]" data-id="element-51">
                PLAN YOUR VISIT
              </Button>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>;
}